export const FILTER_MENU = [
  {
    text: 'По количеству программ',
    value: 'events_count',
  },

  {
    text: 'По количеству профессий',
    value: 'professions_count',
  },
];

export const LIMITS = ['11', '23', '35'];
export const PAGE_SIZE = LIMITS[0];
export const PAGE_NUMBER = 1;
export const DEFAULT_SORT = 'events_count';
export const STORE_MODULE_NAME = 'competencesList';
export const FETCH_ITEMS = 'fetchItems';
export const SET_ITEMS = 'setItems';
export const SET_COUNT = 'setCount';



// WEBPACK FOOTER //
// ./src/pages/competences/list/consts.ts